module.exports = __webpack_public_path__ + "img/svg/box-border.615cc973024aedb897072533b00ab32a.svg";